import { useState } from "react";
import { toast } from "sonner";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { useI18n } from "../../i18n";
import { usePlans } from "../../lib/plans";
import { api, formatError } from "../../lib/api";

const Sel = ({ label, value, onChange, options, testId }) => (
  <div className="space-y-1.5"><Label>{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>{options.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testId}-${v}`}>{l}</SelectItem>)}</SelectContent>
    </Select>
  </div>
);

export const AddMemberDialog = ({ onClose, onCreated }) => {
  const { t } = useI18n();
  const { plans, planName } = usePlans();
  const [f, setF] = useState({ full_name: "", phone: "", password: "", gender: "other", package: plans[0]?.key || "", status: "approved", payment_status: "unpaid" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/admin/users", f); toast.success(t("adm_saved")); onCreated(); }
    catch (err) { toast.error(formatError(err)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" aria-describedby={undefined} data-testid="add-member-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl">{t("adm_add_member")}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-1.5"><Label>{t("f_full_name")}</Label><Input value={f.full_name} onChange={set("full_name")} required data-testid="add-full-name-input" /></div>
          <div className="space-y-1.5"><Label>{t("f_phone")}</Label><PhoneInput international defaultCountry="ET" value={f.phone} onChange={set("phone")} data-testid="add-phone-input" /></div>
          <div className="space-y-1.5"><Label>{t("login_password")}</Label><Input type="password" value={f.password} onChange={set("password")} required minLength={6} data-testid="add-password-input" /></div>
          <Sel label={t("f_gender")} value={f.gender} onChange={set("gender")} options={["male", "female", "other"].map((g) => [g, t(`g_${g}`)])} testId="add-gender" />
          <Sel label={t("adm_package")} value={f.package} onChange={set("package")} options={plans.map((p) => [p.key, planName(p.key)])} testId="add-package" />
          <Sel label={t("adm_status")} value={f.status} onChange={set("status")} options={["pending", "approved", "rejected", "blocked"].map((s) => [s, t(`st_${s}`)])} testId="add-status" />
          <Sel label={t("adm_payment")} value={f.payment_status} onChange={set("payment_status")} options={["unpaid", "submitted", "paid"].map((s) => [s, t(`pay_${s}`)])} testId="add-payment-status" />
          <div className="flex items-end justify-end gap-3 sm:col-span-2">
            <button type="button" onClick={onClose} className="btn-ghost-gold !py-2" data-testid="add-cancel-btn">{t("adm_cancel")}</button>
            <button type="submit" disabled={busy || !f.phone} className="btn-gold !py-2" data-testid="add-submit-btn">{t("adm_create")}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
